module.exports = __webpack_public_path__ + "static/img/xwj3.c6fbd404.png";